export default '/home/runner/work/acquisit/acquisit/node_modules/pdfkit/js'